module.exports = __webpack_public_path__ + "static/img/bulletproofs-large-icon.a7a46e91.png";